import { Dialog, DialogContent, FormControl, FormControlLabel, FormHelperText, Grid2, Switch } from "@mui/material"
import MaterialTypography from "../../../../components/MaterialTypography"
import MaterialBox from "../../../../components/MaterialBox"
import MaterialButton from "../../../../components/MaterialButton"
import MaterialInput from "../../../../components/MaterialInput"
import { useEffect, useState } from "react"
import { postData } from "../../../../services"
import { useSnackbar } from "../../../../context/popup"
import { setCircleLoading } from "../../../../components/Loading"

const CategoryCreateConfirmationDialog = ({showConfirmationBox,setShowConfirmationBox,categoryName,fetchCategoryList}) => {
    
    const { showSnackbar } = useSnackbar();
    const [formData,setFormData] = useState({
        name: categoryName,
        code: "",
        description: "",
        active: true,

        nameStatus: "unchecked",
        codeStatus: "unchecked",
        descriptionStatus: "unchecked",
    });
        
    const [showConfirmationDetails,setShowConfirmationDetails] = useState(false);

    useEffect(() => {
        const cleanedName = categoryName?.replace(/\s*\(New category\)\s*$/i, "").trim() || "";
        
        const alphaNLenghthRegex = /^([\s\S]{1,100})$/;

        setFormData((prev) => ({
            ...prev,
            name: cleanedName,
            nameStatus: cleanedName === "" ? "error" : alphaNLenghthRegex.test(cleanedName) ? "success" : "error",
        }));
    }, [categoryName]);



    const hanldeConfirmClick = () => {
        
        //api post function to be implemented here
        const handleCreateCategory = async () => {
            const payload = { 
                categoryName: formData?.name,
                code: formData?.code,
                description: formData?.description,
                isActive: formData?.active 
            };
            try {
                setCircleLoading(true);
                const response = await postData('/reference/general/key-value-category', payload);
                const responseMessage = response?.message;
                
                if(response?.success){
                    //success pop up
                    setShowConfirmationBox(false);  
                    // await fetchCategoryList();
                    showSnackbar(responseMessage,"success")
                }
                else{
                    //error pop up
                    showSnackbar(responseMessage,"error");
                }
            } catch (error) {
                console.error('Error posting data:', error);
                showSnackbar(error?.response?.data?.message || 'Error Adding data', "error");
            }finally{
                setCircleLoading(false);
            }
        };
        handleCreateCategory();

    }

    const handleChange = (event) => {

        let formState ={...formData};

        if(event && event.target){
            switch(event.target.name){
                case "name": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,50})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "code": {
                    const codeRegex = /^[A-Z0-9_]{1,25}$/;

                    formState[event.target.name + "Status"] = codeRegex.test(event.target.value.trim())
                    ? "success"
                    : event.target.value === ""
                    ? "unchecked"
                    : "error";

                    break;
                }

                case "description": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,200})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setFormData(formState);
    }

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
        formData.nameStatus === "success" &&
        formData.descriptionStatus === "success"
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }

        return allowSubmit;
    }

  return (
    <Dialog open={showConfirmationBox}>
        <DialogContent>
            {!showConfirmationDetails ? (
            // Form
            <>
            <MaterialBox justifyContent="center" >
                    <MaterialTypography 
                    variant="h4"
                    align="center"
                    fontWeight="bold"
                    >
                        Enter Category Details
                    </MaterialTypography>
                </MaterialBox>
            <MaterialBox mt={3}>
                <Grid2 container spacing={1} alignItems="center">
                    <Grid2 size={{lg:12, md:12, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            >
                                Category Name*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="name"
                        value={formData?.name}
                        onChange={handleChange}
                        success={formData.nameStatus === "success"}
                        error={formData.nameStatus === "error"}
                        disabled
                        />
                        {formData.nameStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Category Name should be between 1-50 characters
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:12, md:12, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            >
                                Category Code*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name="code"
                        value={formData?.code}
                        onChange={handleChange}
                        success={formData.codeStatus === "success"}
                        error={formData.codeStatus === "error"}
                        />
                        {formData.codeStatus === "error" && (
                            <FormControl error>
                                <FormHelperText>
                                Category Code should be between 1-25 characters with only Capital Alphabets amd Underscore
                                </FormHelperText>
                            </FormControl>
                        )}
                    </Grid2>
                    <Grid2 size={{lg:12, md:12, sm: 12, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            >
                                Description*
                            </MaterialTypography>
                        </MaterialBox>
                        <MaterialInput
                        name= "description"
                        value={formData?.description}
                        onChange={handleChange}
                        multiline
                        rows={3}
                        success={formData.descriptionStatus === "success"}
                        error={formData.descriptionStatus === "error"}
                        />
                        {formData.descriptionStatus === "error" ? (
                            <FormControl error>
                                <FormHelperText>
                                Description should be between 1-200 characters
                                </FormHelperText>
                            </FormControl>
                        ):
                            <FormControl>
                                <FormHelperText>
                                Description should be between 1-200 characters
                                </FormHelperText>
                            </FormControl>
                        }
                    </Grid2>
                    <Grid2 size={{lg:2, md:2, sm: 6, xs: 12 }}>
                        <MaterialBox>
                            <MaterialTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold">
                                Actve
                            </MaterialTypography>
                        </MaterialBox>
                        <FormControlLabel
                        control={
                            <Switch
                                checked={formData.active}
                                onChange={(e) =>
                                    handleChange({
                                        target: {
                                            name: "active",
                                            value: e.target.checked,
                                        },
                                    })
                                }
                                color="primary"
                            />
                        }
                        label={
                            <MaterialTypography variant="caption" fontWeight="bold">
                                {formData?.active ? "Yes" : "No"}
                            </MaterialTypography>
                        }
                        sx={{ marginLeft: 0 }}
                        />
                    </Grid2>
                </Grid2>  
            </MaterialBox>  
            <MaterialBox
            mt={2}
            display="flex"
            justifyContent="space-between"
            alignItems="center">
                <MaterialButton
                    sx={{ m: 1 }}
                    variant="outlined"
                    color="dark"
                    size="small"
                    onClick={() => setShowConfirmationBox(false)}
                    >
                    Cancel
                    </MaterialButton>
                    <MaterialButton
                    sx={{ m: 1 }}
                    variant="gradient"
                    color="dark"
                    size="small"
                    disabled={!checkAllFields()}
                    onClick={() => setShowConfirmationDetails(true)}
                    >
                    Submit
                </MaterialButton>
            </MaterialBox> 
            </>       
            )
            : (
            //Confirmation Box
            <>            
                {/* Title */}
                <MaterialBox justifyContent="center" >
                    <MaterialTypography 
                    variant="h4"
                    align="center"
                    fontWeight="bold"
                    >
                        Are you sure?
                    </MaterialTypography>
                </MaterialBox>

                {/* Content */}
                <MaterialBox
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    p={3}
                >
                    <MaterialTypography align="center" variant="body2">
                    Are you sure you want to create this new category with the name{" "}
                    <strong>{formData?.name}</strong>?
                    This action can't be undone.
                    </MaterialTypography>

                    <MaterialBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    mt={3}
                    >
                    <MaterialButton variant="outlined" color="dark"
                    onClick={() => setShowConfirmationBox(false)}
                    >
                        Cancel
                    </MaterialButton>
                    <MaterialButton variant="gradient" color="dark" onClick={hanldeConfirmClick}>
                        Confirm
                    </MaterialButton>
                    </MaterialBox>
                </MaterialBox>
            </>

            )}
        </DialogContent>

    </Dialog>
  )
}

export default CategoryCreateConfirmationDialog